import { create } from 'zustand';
import type { AgentId } from '@/services/ws/types';

/** Observations older than this are treated as stale and hidden. Single
 *  source of truth — `ObservationsStrip` imports this rather than re-declaring. */
export const STALENESS_MS = 5 * 60 * 1000;
const CAP = 10;

export interface Observation { id: string; agentId: AgentId; text: string; ts: number; }

interface ObservationsState {
  list: Observation[];
  add: (o: Observation) => void;
  listFresh: (now: number) => Observation[];
  reset: () => void;
}

export const useObservations = create<ObservationsState>((set, get) => ({
  list: [],
  add: (o) => set((s) => ({ list: [...s.list, o].slice(-CAP) })),
  listFresh: (now) => get().list.filter((o) => now - o.ts <= STALENESS_MS),
  reset: () => set({ list: [] }),
}));
